import FilterAirlineCombinationComponent from "../FilterAirlineCombinationComponent";
import FilterAirlinesComponent from "../FilterAirlinesComponent";
import FilterAirportsComponent from "../FilterAirportsComponent";
import FilterArrivalTimeComponent from "../FilterArrivalTimeComponent";
import FilterBaggageComponent from "../FilterBaggageComponent";
import FilterDepartureTimeComponent from "../FilterDepartureTimeComponent";
import FilterDurationComponent from "../FilterDurationComponent";
import FilterPriceRangeComponent from "../FilterPriceRangeComponent";
import FilterTransfersComponent from "../FilterTransfersComponent";

import { Wrapper } from "./style";

const FilterBlockComponent = () => {
  return (
    <Wrapper>
      {/* FE-14: порядок как в макете — сначала то, чем пользуются чаще */}
      <FilterTransfersComponent />
      <FilterBaggageComponent />
      <FilterAirlineCombinationComponent />
      <FilterPriceRangeComponent />
      <FilterAirlinesComponent />
      <FilterDepartureTimeComponent />
      <FilterArrivalTimeComponent />
      <FilterDurationComponent />
      <FilterAirportsComponent />
    </Wrapper>
  );
};

export default FilterBlockComponent;
